<div class="user-feedback-container">
    <h4 class="feedback-header-label">{{'AI_AGENT.WHY_WASNT_THIS_HELPFUL' | translate}}</h4>
    <div class="feedback-options">
        <div *ngFor="let option of feedbackOptions" class="radio-option">
            <!-- <nalco-radio-button
                [radioButton]="option"
               
                (radioButtonClick)="onOptionChange($event)"
                class="nalco-radio-input">
            </nalco-radio-button> -->
            <input type="radio" [id]="'feedback-' + option.id" [name]="'feedback-option'" [value]="option.value"
                [(ngModel)]="selectedOption" (change)="onOptionChange(option)" class="radio-input" />
            <label [for]="'feedback-' + option.id" class="radio-label">
                <span class="radio-button"></span>
                <span class="radio-text ps-2">{{ option.text }}</span>
            </label>
        </div>
    </div>

    <div *ngIf="showOtherTextarea" class="other-feedback-section">
        <label for="additional-feedback" class="textarea-label">
            {{'AI_AGENT.ANYTHING_ELSE_TO_ADD' | translate}}
        </label>
        <textarea id="additional-feedback" class="feedback-textarea" placeholder="Enter your feedback..."
            [(ngModel)]="additionalFeedback" (input)="onAdditionalFeedbackChange()" rows="4">
    </textarea>
    </div>

    <!-- <div class="feedback-actions" *ngIf="selectedOption">
        <button type="button" class="submit-btn" [disabled]="!isValidFeedback" (click)="submitFeedback()">
            Submit Feedback
        </button>
        <button type="button" class="cancel-btn" (click)="resetFeedback()">
            Cancel
        </button>
    </div> -->
</div>